<template>
    <el-dialog title="在籍考生登录" :visible.sync="visible" width="500px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
        <div class="formBox">
            <el-form ref="form" :model="form">
                <el-form-item prop="zsCatalogId" label-width="0">
                    <el-radio-group v-model="index" @change="changeRadio">
                      <div v-for="(v,i) in list" :key="i" class="radioLi">
                        <el-radio :label="i">{{ v.certiNo }} ({{ v.name }})</el-radio>
                        <div class="infoBox">
                          <div class="infoLi">
                            <p>专业：</p>
                            <p>{{ v.specialtyCode+'-'+v.specialtyName }}</p>
                          </div>
                          <div class="infoLi">
                            <p>层次：</p>
                            <p>{{ v.specialtyEdulevel }}</p>
                          </div>
                        </div>
                      </div>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <p class="submit" @click="submit">登录</p>
        </div>
    </el-dialog>
</template>

<script>
import { mapState } from "vuex";
// import { chooseSpecialty,login } from "@/api/index";
  export default {
    props: {},
      computed: {
    },
    data() {
      return {
        visible: false,
        form:{
          studentRegType:'',
          registerId:'',
          orgId:''
        },
        index: 0,
        list:[],
      };
    },
    mounted() {
    },
    methods: {
      open(res) {
        this.list = res
        this.index = 0
        this.visible = true;
      },
      changeRadio(index){
        this.index = index
      },
      async submit() {
        const params = {
          account: this.list[this.index].certiNo,
          registerInfoId: this.list[this.index].id,
        }
        const _this = this
        _this.$http.post('/student/pc/login', params).then((res) => {
          _this.$store.commit("SET_TOKEN", res.token);
          _this.$store.commit("SET_SCHOOLINFO", res);
          _this.$http.get('/student/pc/getStudentInfo').then((res) => {
            localStorage.setItem('login_choose', JSON.stringify(_this.list))

            _this.$store.commit("LOGIN", res);
            // 触发登录成功事件
            _this.$emit('success')
            _this.$router.push({ path: "/main/home" });
          })
        })
      },
    },
  };
</script>
<style lang="scss" scoped>
::v-deep(.el-dialog){
  border-radius: 10px;
  overflow: hidden;
  z-index: 9999 !important;
}
::v-deep(.el-dialog__wrapper){
  z-index: 9999 !important;
}
::v-deep(.el-dialog__header){
  // background: url(../assets/contactus.png) 100% 100%;
  text-align: center;
}
::v-deep(.el-radio-group){
  font-size: 14px;
}
::v-deep(.el-radio__label){
  font-size: 14px;
  color: #368EE0;
  line-height: 36px;
}
.radioLi{
  margin-bottom: 15px;
    width: 480px;
    background: #f0f0f0;
    box-sizing: border-box;
    padding: 5px 10px 10px 10px;
    border-radius: 5px;
  .infoBox{
    box-sizing: border-box;
    padding-left: 25px;
    .infoLi{
      display: flex;
      align-items: center;
      height: 20px;
    }
  }
}
.submit{
  background-color: #368EE0;
  color: #FFFFFF;
  width: 100px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  border-radius: 4px;
  margin: 10px auto 10px auto;
  cursor: pointer;
}
.red{
  color: #ee4545;
}
.blue{
  color: #368EE0;
}
</style>
